import { Controller } from "stimulus";

export default class extends Controller {

  connect() {
    this.toggleBtn = this.element.querySelector('.share-toggle');
    this.shareLinks = this.element.querySelector('.share-links');
  }

  share(event) {
    event.preventDefault();
    let target = event.currentTarget;
    let href = target.href;
    let type = target.dataset.shareType;
    let height = target.dataset.height;
    let width = target.dataset.width;
    // Calculate the position of the popup so
    // it’s centered on the screen.
    let left = screen.width / 2 - width / 2;
    let top = screen.height / 2 - height / 2;
    let options = `height=${height},width=${width},top=${top},left=${left}resizable=1`;
    window.open(href, type, options);
  }

  open() {
    this.shareLinks.classList.add('active');
    this.toggleBtn.classList.add('hide');
  }
}
